import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import 'intersection-observer';
import smoothscroll from 'smoothscroll-polyfill';
// import authentication from 'react-azure-b2c';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';

// authentication.run(() => {
// 	smoothscroll.polyfill();
// 	ReactDOM.render(<App />, document.getElementById('root'));
// 	serviceWorker.unregister();
// });

smoothscroll.polyfill();
ReactDOM.render(<App />, document.getElementById('root'));
serviceWorker.unregister();
